import { Component, Input, OnChanges, OnInit, Output } from '@angular/core';
import { FormBuilder } from '@angular/forms';
import { MatDialog } from '@angular/material/dialog';
import { ActivatedRoute } from '@angular/router';
import { IServiceFactory } from 'src/app/Services/service-factory';
import { ToastrService } from 'ngx-toastr';
import { CurriculumService } from 'src/app/Services/curriculum.service';
import { CurriculumProductLevel, CurriculumProductLevelPrice, ConsumerCurriculumJargon, CurriculumProductLevelConfig } from 'src/app/Elearning-Models';
import { EventEmitter } from '@angular/core';

@Component({
  selector: 'app-product-level-picker',
  templateUrl: './product-level-picker.component.html',
  styleUrls: ['./product-level-picker.component.scss']
})
export class ProductLevelPickerComponent implements OnInit, OnChanges {

  @Input() selectedStudentID: number;
  @Input() jargon: ConsumerCurriculumJargon;
  @Input() isNewcomer: boolean;
  @Input() curriculumID: number;
  @Input() productLevelID: number;
  @Input() hasUnitTests: boolean;
  @Input() lessonCount: number;
  @Output() selectedProductLevel: EventEmitter<CurriculumProductLevelPrice> = new EventEmitter<CurriculumProductLevelPrice>();
  
  
  public dataService: CurriculumService;
  public priceInfoReceived: boolean = false;
  public productLevelPrices: CurriculumProductLevelPrice[];

  selectedProductLevelPriceID: number;
  

  constructor(
    public dialog: MatDialog,
    private serviceFactory: IServiceFactory
  ) {
    this.dataService = serviceFactory.getCurriculumService();
  }

  ngOnInit(): void {
    
      // this.dataService.CheckIsNewComer().subscribe(result => {
      //   this.isNewcomer = result;
      //   this.getCurriculumProductLevelPrice();
      // });
      var flooredCount = Math.floor(this.lessonCount / 10) * 10;
      this.lessonCount = flooredCount == this.lessonCount ? flooredCount - 10 : flooredCount;
      this.getCurriculumProductLevelPrice();
  }
  
  ngOnChanges() : void {
    
  }

  getCurriculumProductLevelPrice() {
    this.serviceFactory.getCurriculumService().GetCurriculumProductLevelPrice(this.curriculumID)
      .subscribe((prices: CurriculumProductLevelPrice[])=> {
        this.productLevelPrices = [];
        this.productLevelPrices = prices;

        this.selectedProductLevelPriceID = this.productLevelID ? 
        this.productLevelPrices.find(p => p.ICurriculumProductLevel.ID == this.productLevelID)?.ICurriculumProductLevel.ID : 0;


        var demoProduct: CurriculumProductLevel = {
          ID: 0,
          Name: this.jargon.DemoAllFirstLetterCaps,
          Description: "Determine if your student needs help by taking this short, free diagnostic exam." +
          " After your student completes this exam, you will receive a free diagnostic report that suggests the next steps to their success.",
          Config: {
            HasLessonMax: true,
            LessonMax: 15
          }
        }

        if(!this.hasUnitTests){
          this.productLevelPrices.forEach(p => p.ICurriculumProductLevel.Description = p.ICurriculumProductLevel.Description.replace('<li>Unit Tests</li>', ''));
        }

        this.productLevelPrices.forEach(p => p.ICurriculumProductLevel.Description = p.ICurriculumProductLevel.Description.replace('-', this.lessonCount.toString()))


    
        var demoPrice: CurriculumProductLevelPrice = {
          CurriculumProductLevelID: 0,
          DefaultPrice: 0,
          ICurriculumProductLevel: demoProduct,
          Active: true 
        }

        if(this.isNewcomer){
          this.productLevelPrices = [];
          this.productLevelPrices.push(demoPrice);
        }
        else{
          this.productLevelPrices.unshift(demoPrice);
        }

        var price = this.productLevelPrices.find(p => p.CurriculumProductLevelID == this.selectedProductLevelPriceID);
       // this.productLevelChange(price);


        this.priceInfoReceived = true
      });
  }

  productLevelChange(value: CurriculumProductLevelPrice){ 
    if(this.selectedStudentID > 0){
      this.selectedProductLevel.emit(value);
    }
  }

}
 